import Licensee from "@/model/licensee.mjs";
import { TransferStatus } from "../transfer-status.mjs";
import { FirearmType } from "../firearm-type.mjs";
import Transfer, { TransferMetadata } from "../transfer.mjs";
import { TransferMicrostatus } from "@/queue/types";

export interface FFLListTransfer {
    items: FFLListTransfer[];
}

export interface FFLListTransfer {
    id: string; // 5
    createdBy: string // ruchinfreelancer@gmail.com
    modifiedBy: string // ruchinfreelancer@gmail.com
    key: string // 15400040
    status: TransferStatus
    referenceId: string;
    name: string;
    buyerName?: string
    firearm: FirearmType;
    agent: string
    notes: Array<string>
    storeURL?: string;
    orderDate?: Date;
    buyerPhone: string;
    buyerEmail: string;
    modelType: string;
    street?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    startDate?: Date;
    endDate?: Date;
    licensee?: Licensee;
    createdAt?: Date;
    transfer_code?: string;
    storeName?: string;
    derivedStatus?: string;
    microStatus?: TransferMicrostatus;
    age: string;
    transferCode?: string
    isArchive?: boolean;
    archiveDate?: Date | null;
    transferType: string;
    microStatusCount?: Number;
    inboundTransferCompletionTime?: Date | null;
    outboundTransferCompletionTime?: Date | null;
    transferCompletionTime?: Date | null
    sellerName?: string;
    is_external?: boolean;
    source: string;
    recieverDealerId?: string;
    sellerDealerId?: string;
    ecommerce_status?: string | null;
    is_reassigned?: boolean;
    pendingDocuments?: Array<string>;
    sellerLicenseKey?: string | null;
    metaSellerName?: string | null;
    sellerDealerIdFromSellerLicenseKey?: string | null;
    transferMetadata?: TransferMetadata | null;
    store_id: string;
    linkedFromTransferId?: string | null;
    isLinkedTransfer?: boolean;
    transferId?: string | null;
    isSharedTransfer?: boolean;
    sellerUsername?: string | null;
    receiverDealerTimezone?: string | null;
    sellerDisplayName?: string | null;
    receiver_dealer_timezone?: string | null;
    seller_display_name?: string | null;
    lastDealerEvent?: string | null;
    last_dealer_event?: string | null;
}

export default class TransferBuilder {
    static buildTransfer(i: FFLListTransfer): Transfer {
        const result: Transfer = {
            id: i.id,
            key: i.key,
            status: i.status,
            referenceId: i.referenceId,
            buyerName: i.name,
            firearm: i.firearm,
            startDate: i.startDate,
            endDate: i.endDate,
            licensee: i.licensee,
            notes: i.notes,
            storeURL: i.storeURL,
            orderDate: i.orderDate,
            buyerPhone: i.buyerPhone,
            buyerEmail: i.buyerEmail,
            modelType: i.modelType,
            street: i.street,
            city: i.city,
            state: i.state,
            zipCode: i.zipCode,
            createdAt: i.createdAt,
            agent: i.agent,
            transferCode: i.transfer_code,
            storeName: i.storeName,
            derivedStatus: i.derivedStatus,
            microStatus: i.microStatus,
            age: i?.age,
            isArchive: i?.isArchive,
            archiveDate: i?.archiveDate,
            transferType: i.transferType,
            inboundTransferCompletionTime: i?.inboundTransferCompletionTime,
            outboundTransferCompletionTime: i?.outboundTransferCompletionTime,
            transferCompletionTime: i?.transferCompletionTime,
            sellerName: i?.sellerName,
            is_external: i?.is_external,
            source: i.source,
            recieverDealerId: i?.recieverDealerId,
            sellerDealerId: i?.sellerDealerId,
            ecommerce_status: i?.ecommerce_status,
            is_reassigned: i?.is_reassigned,
            pendingDocuments: i?.pendingDocuments,
            sellerLicenseKey: i?.sellerLicenseKey,
            metaSellerName: i?.metaSellerName,
            sellerDealerIdFromSellerLicenseKey: i?.sellerDealerIdFromSellerLicenseKey,
            transferMetadata: i?.transferMetadata,
            store_id: i?.store_id || '',
            linkedFromTransferId: i?.linkedFromTransferId,
            isLinkedTransfer: i?.isLinkedTransfer,
            transferId: i?.transferId,
            isSharedTransfer: i?.isSharedTransfer,
            sellerUsername: i?.sellerUsername,
            receiverDealerTimezone: i?.receiverDealerTimezone ?? i?.receiver_dealer_timezone,
            sellerDisplayName: i?.sellerDisplayName ?? i?.seller_display_name,
            lastDealerEvent: i?.lastDealerEvent ?? i?.last_dealer_event,
        };

        return result;
    }

    static buildTransferList(i: FFLListTransfer): Transfer[] {
        return i.items.map(item => TransferBuilder.buildTransfer(item));
    }
}
